import Link from '@tiptap/extension-link';

export function configureLink() {
  return Link.configure({
    validate: (href) => /^https?:\/\//.test(href),
  });
}
